import { Component, OnInit, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-wiki',
  templateUrl: './wiki.component.html',
  styleUrls: ['./wiki.component.scss']
})
export class WikiComponent {
  @Input() public menid: string;

  constructor(
    private router: Router,
    @Inject('DOC_URL') private docUrl: string
  ) { }

  goToDoc() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`${this.docUrl}wikis/documentationview`],
        {
          queryParams: {
            menid: this.menid
          }
        }
      )
    );
    window.open(url, '_blank');
  }
}
